import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef } from "vue"

import { ref, PropType, computed, watch, Ref } from 'vue'
import useI18nTl from '@/hooks/useI18nTl'
import AlarmI18nSolutions from './AlarmI18nSolutions.vue'
import AlarmI18nNames from './AlarmI18nNames.vue'
import { upsertAlarmRepository } from '@/api/operation'
import { ElMessage, ElMessageBox } from 'element-plus'
import FormRulesFactory from '@/common/formRules'
import useProtocolEnums from '@/hooks/useProtocolEnums'


import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'AlarmsRepositoryUpsert',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  isEdit: {
    type: Boolean,
  },
  info: {
    type: Object,
    default: () => ({}),
  },
},
  emits: ['update:modelValue', 'submit', 'submitted'],
  setup(__props, { emit }) {

const props = __props

const { alarmTypes, evseProtocols, alarmLevels } = useProtocolEnums()

const { t, tl } = useI18nTl('Operation')
const formRule = ref({
  ...FormRulesFactory.generateCustomRules(
    ['alarmCode', 'subAlarmCode'],
    'inputEmpty',
    'inputInvalid',
  ),
  ...FormRulesFactory.generateCustomRules(
    ['protocol', 'type', 'level'],
    'selectNone',
    'selectNone',
  ),
})


let subsForm = ref()
const record = ref<Record<string, any>>({
  i18nAlarmNames: [],
  i18nSolutions: [],
})
const showDialog = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit('update:modelValue', val)
    if (!val) {
      subsForm.value?.clearValidate()
      // record.value = {
      //     i18nAlarmNames: [],
      //     i18nSolutions: [],
      // }
    }
  },
})

const submit = async () => {
  await subsForm.value?.validate()

  // record.value.tmpl.amountType = AmountType.AT_TOTAL_AMOUNT
  upsertAlarmRepository({ alarmRepository: record.value }).then((res: any) => {
    if (props.isEdit) {
      ElMessage.success(t(`Base.editSuccess`))
    } else {
      ElMessage.success(t(`Base.createSuccess`))
    }
    showDialog.value = false
    emit('submitted')
  })
}
watch(
  () => props.modelValue,
  (val) => {
    if (props.isEdit) {
      record.value.id = props.info?.id
      record.value.alarmCode = props.info?.alarmCode
      record.value.subAlarmCode = props.info?.subAlarmCode
      record.value.protocol = props.info?.protocol
      record.value.type = props.info?.type
      record.value.level = props.info?.level
      record.value.remark = props.info?.remark
      record.value.i18nAlarmNames = props.info?.i18nAlarmNames
      record.value.i18nSolutions = props.info?.i18nSolutions
    } else {
      subsForm.value?.clearValidate()
      record.value = {
        i18nAlarmNames: [],
        i18nSolutions: [],
      }
    }
  },
  { immediate: true },
)

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    title: props.isEdit ? _unref(t)('Evses.editAlarmRepository') : _unref(t)('Evses.addAlarmRepository'),
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    "lock-scroll": false,
    "close-on-click-modal": true,
    size: "50%",
    "z-index": 1999,
    "custom-class": "ar-drawer"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[6] || (_cache[6] = ($event: any) => (showDialog.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: !_ctx.$hasPermission('post'),
        onClick: submit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.isEdit ? _ctx.$t('Base.saveChanges') : _ctx.$t('Base.add')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        "label-position": "top",
        "require-asterisk-position": "right",
        model: record.value,
        "validate-on-rule-change": false,
        ref_key: "subsForm",
        ref: subsForm,
        rules: formRule.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Evses.alarmCode'),
                    prop: "alarmCode",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.alarmCode,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((record.value.alarmCode) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Evses.subAlarmCode'),
                    prop: "subAlarmCode"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.subAlarmCode,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((record.value.subAlarmCode) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Evses.evseProtocol'),
                    prop: "protocol",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: record.value.protocol,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((record.value.protocol) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(evseProtocols), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Evses.alarmType'),
                    prop: "type",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: record.value.type,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((record.value.type) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(alarmTypes), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Evses.alarmLevel'),
                    prop: "level",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: record.value.level,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((record.value.level) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(alarmLevels), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.desc'),
                    prop: "remark"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        modelValue: record.value.remark,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((record.value.remark) = $event)),
                        rows: 1
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_divider)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Evses.alarmName')
                  }, null, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(AlarmI18nNames, {
                    list: record.value.i18nAlarmNames
                  }, null, 8, ["list"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_divider)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.solution')
                  }, null, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(AlarmI18nSolutions, {
                    list: record.value.i18nSolutions
                  }, null, 8, ["list"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})